// extracted by mini-css-extract-plugin
export default {"modalBlock":"Modal_modalBlock__nBYy-","modalContent":"Modal_modalContent__5HA4z","closeBlock":"Modal_closeBlock__SQlky"};